module.exports = __webpack_public_path__ + "static/85degres-31f571baa7f66e1c3201e7d54b12a21e.jpg";